<template>
    <div class="airboard" :class="classLoading">
        <div class="panel panel__main" :class="getClass()" :id="idView">
            <div class="panel__menuBar" v-if="$slots.menuBar">
                <slot name="menuBar"></slot>
            </div>
            <div class="panel__head" v-if="$slots.head">
                <slot name="head"></slot>
            </div>
            <div class="panel__body" v-if="$slots.body">
                <slot name="body"></slot>
            </div>
            <slot name="tab"></slot>
        </div>

        <!-- zona comercial -->
        <ui-PanelOverlay
            panel="commercial"
            :style="'background-image: url(https://mysair.es/spa/images/commercial-back-1.jpg);'"
        >
        </ui-PanelOverlay>

        <slot name="panels"></slot>
    </div>
</template>

<script>
    import ui_PanelOverlay from './ui-PanelOverlay.vue';
    import { ui_LoadingMixin } from './ui-LoadingMixin';

    export default {
        components: {
            ui_PanelOverlay,
        },
        name: 'ui-Airboard',
        mixins: [ui_LoadingMixin],
        props: {
            panel: String,
            idView: String,
            openTab: {
                type: Boolean,
                default: false,
            },
            feedback: {
                type: Boolean,
                default: false,
            },
            classStyles: String, // clases adicionales a incorporar
        },
        methods: {
            getClass: function() {
                var classStyles = this.panel ? `panel__${this.panel}` : '';

                if (this.openTab) classStyles = classStyles + ' panel--openTab';
                if (this.feedback) classStyles = classStyles + ' panel--feedback';
                if (this.classStyles != undefined) classStyles = `${classStyles} ${this.classStyles}`;

                return classStyles;
            },
        },
    };
</script>
